<template>
  <div id="app">
    <router-view></router-view>
    <div style="display:none;">
      <audio id="xdshdd">
        <source src="static/xdshdd.mp3" />
      </audio>
      <audio id="xdbdd">
        <source src="static/xdbdd.mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex'

  export default {
    name: 'app',
    data() {
      return {}
    },
    methods: {
      AutoLogin() {
        let _this = this;
        this.$http({
          method: 'post',
          url: '/AutoLogin',
        }).then(function (result) {
          if (result.data.code == 0) {
            _this.$store.commit('SetLogin', true);
          }
        }).catch(function (error) {
          console.log(error);
        })
      },
    },
    mounted() {
      if (!this.login) {
        this.AutoLogin();
      }
    },
    computed: {
      ...mapGetters([
        "login"
      ]),
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue